var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUzFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.875 5H5.125C3.05406 5 2 6.53906 2 8.4375V11.875H22V8.4375C22 6.53906 20.9459 5 18.875 5Z",
    fill: "#1B75BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.3125C2 17.2109 3.05406 18.75 5.125 18.75H18.875C20.9459 18.75 22 17.2109 22 15.3125V11.875H2V15.3125Z",
    fill: "#F9CB38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2428_42280)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2428_42280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 15H22V20H2V15Z",
    fill: "#1EB53A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5H22V10H2V5Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.80005H22V15.2H2V9.80005Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10.1001H22V14.9001H2V10.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20039 9.2001C7.1945 9.2001 8.00039 8.39421 8.00039 7.4001C8.00039 6.40599 7.1945 5.6001 6.20039 5.6001C5.20628 5.6001 4.40039 6.40599 4.40039 7.4001C4.40039 8.39421 5.20628 9.2001 6.20039 9.2001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8 9.2001C7.79411 9.2001 8.6 8.39421 8.6 7.4001C8.6 6.40599 7.79411 5.6001 6.8 5.6001C5.80589 5.6001 5 6.40599 5 7.4001C5 8.39421 5.80589 9.2001 6.8 9.2001Z",
    fill: "#0099B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 8.48071L10.0459 8.82271L10.2199 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1594 8.48071L10.2734 8.82271L10.0994 8.88271",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.502 8.72951L10.1415 8.72678L10.1383 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 8.72948L10.2119 8.94358L10.101 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81746 8.72948L10.1075 8.94358L10.2183 8.79665",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81731 8.72951L10.1778 8.72678L10.1811 8.9108",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 9.13195L10.2628 8.78826L10.0868 8.84199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3715 9.13197L10.0783 8.92229L10.1838 8.77148",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94878 9.13198L10.2421 8.92231L10.1366 8.77151",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94867 9.13195L10.0575 8.78826L10.2335 8.84199",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2428_42280"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5,
    width: 20,
    height: 14,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2428_42280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(2 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzFlag);
export default __webpack_public_path__ + "static/media/UZ_flag.867331cee088883fb1c5af85c6fe1c2f.svg";
export { ForwardRef as ReactComponent };